import {
    CLEAR_TIMEOUT,
    TIMEOUT_TICK,
    SET_TIMEOUT,
    timerWorkerScript,
} from "./TimerWorker";
import { enxLog } from '../helpers.js';

export default class StreamBackgroundEffect {
    constructor(model, options, forWhat) {
        enxLog('StreamBackgroundEffect initialized..');
        this._options = options;
        this.frameRate = 60;

        this._virtualImage = document.createElement("img");
        this._virtualImage.crossOrigin = "anonymous";
        this._virtualImage.src = this._options.selectedImageData;

        if (forWhat == 'preview') {
            this._outputCanvasElementId = 'vb-preview-input-canvas-element';
            this._inputVideoElementId = 'vb-preview-input-video-element';
            this._stream = options.previewStream;
            this.localStream = this._options.previewStream;

        } else {
            this._outputCanvasElementId = 'vb-main-output-canvas-element';
            this._inputVideoElementId = 'vb-main-output-video-element';
            this._stream = options.stream;
            this.localStream = this._options.stream;
        }

        if (document.querySelector(`#${this._outputCanvasElementId}`)) {
            document.querySelector(`#${this._outputCanvasElementId}`).remove();
        }
        if (document.querySelector(`#${this._inputVideoElementId}`)) {
            document.querySelector(`#${this._inputVideoElementId}`).remove();
        }

        this._model = model;

        this._segmentationPixelCount = this._options.width * this._options.height;

        // Bind event handler, so it is only bound once for every instance.
        this._onMaskFrameTimer = this._onMaskFrameTimer.bind(this);
        enxLog('Setting done for worker thread...');

        // Workaround for FF issue https://bugzilla.mozilla.org/show_bug.cgi?id=1388974
        this._outputCanvasElement = document.createElement("canvas");
        this._outputCanvasElement.id = this._outputCanvasElementId;
        this._outputCanvasElement.getContext("2d", { willReadFrequently: true });

        this._inputVideoElement = document.createElement("video");
        this._inputVideoElement.id = this._inputVideoElementId;

        this.localStreamId = options.stream.getID();
    }

    startPreview(forWhat = "preview") {
        if (forWhat == "preview") {
            this.previewPlayer = this._options.previewDomElement;
            if (this._options.previewStream?.stream) {
                this.updatedStream = this.estartEffect(this._options.previewStream.stream, 'preview');
                this.previewPlayer.srcObject = this.getStream();
                enxLog('previewPlayer updated');
            }
        } else {
            if (this._options.background.type != "none") {
                this.updatedStream = this.estartEffect(this._options.stream.stream, 'main');
            } else {
                if (document.querySelector(`#${this._outputCanvasElementId}`)) {
                    document.querySelector(`#${this._outputCanvasElementId}`).remove();
                }
                if (document.querySelector(`#${this._inputVideoElementId}`)) {
                    document.querySelector(`#${this._inputVideoElementId}`).remove();
                }
                this.localStream.changeInputMediaSource({
                    stream: null, audio: true, video: true
                }, (res) => {
                    console.log('res -- changeInputMediaSource 2: ', res);
                });
            }
        }
        
    }


    getStream() {
        return this._options.background.type != "none" ? this.updatedStream : this.localStream.stream;
    }


    async applyEffects() {
        let _this = this;
        enxLog('starting to apply Effects');

        // enxLog(JSON.stringify(this._options.background));


        if (this._options.background) {
            this.parentObject.setBackground = this._options.background
        }

        try {
            enxLog('Executing apply Effects');
            // console.log('this._options.background.type:', this._options.background.type);
            // replace the tracks of localstream from tracks of updated stream

            // This is for Image or blur
            if (this._options.background.type != "none") {
                enxLog('inside -> not none bg');
                this.localStream.changeInputMediaSource({
                    stream: null, audio: true, video: true
                }, (res) => {
                    console.log('res -- changeInputMediaSource 2: ', res);
                });

                await this.localStream.changeInputMediaSource({
                    stream: this.updatedStream,
                    audio: false,
                    video: true
                }, (res) => {
                    enxLog('res -- changeInputMediaSource');
                });
            }
            // This is for bg NONE
            else {
                await this.localStream.changeInputMediaSource({
                    stream: null, audio: true, video: true
                }, (res) => {
                    console.log('res -- changeInputMediaSource 2: ', res);
                });
            }
            enxLog('Applying Effects executed');

            this.handleVideoPlayers();
            // this._options.handleApplyEffect();
            enxLog('end applyEffects');
        }
        catch (err) {
            console.log(err);
        }
    }

    /**
     * Update player's source
     */
    handleVideoPlayers() {
        // const _this = this;
        // let gridPlayer = this._options.domElement;
        // if (gridPlayer.length === 1) {
        //     enxLog('Updating local video single');
        //     gridPlayer[0].srcObject = this.getStream();
        // } else if (gridPlayer.length > 1) {
        //     gridPlayer.forEach((item, index) => {
        //         enxLog('Updating local video multiple');
        //         item.srcObject = _this.getStream();
        //     });
        // }
        // let sidebarPlayer = document.querySelector(`#${this._options.localVideoId} video`);
        // if (sidebarPlayer) {
        //     enxLog('Updating src of sidebar player');
        //     sidebarPlayer.srcObject = this.getStream();
        // }
    }

    _onMaskFrameTimer(response) {
        if (response.data.id === TIMEOUT_TICK) {
            this._renderMask();
        }
    }

    runPostProcessing() {
        if (this.localStream && this.localStream.stream && this.localStream.stream.getVideoTracks()[0]) {
            const track = this.localStream.stream.getVideoTracks()[0];
            const { height, width } = track.getSettings() ?? track.getConstraints();
            // const { type } = this._options.background;
    
            this._outputCanvasElement.height = height;
            this._outputCanvasElement.width = width;
            this._outputCanvasElement.style.position = 'absolute';
            this._outputCanvasElement.style.top = '0';
            this._outputCanvasElement.style.right = '0';
            this._outputCanvasElement.style.zIndex = '9990';
            this._outputCanvasElement.style.height = `${height}px`;
            this._outputCanvasElement.style.width = `${width}px`;
    
    
            this._inputVideoElement.height = height;
            this._inputVideoElement.width = width;
            this._inputVideoElement.style.height = `${height}px`;
            this._inputVideoElement.style.width = `${width}px`;
    
    
            this._outputCanvasCtx.globalCompositeOperation = "copy";
    
            // Draw segmentation mask.
            // Smooth out the edges.
            if (this._options.background.type == "vb") {
                this._outputCanvasCtx.filter = "blur(4px)";
            } else {
                this._outputCanvasCtx.filter = "blur(8px)";
            }
    
            this._outputCanvasCtx.drawImage(
                this._segmentationMaskCanvas,
                0,
                0,
                this._options.width,
                this._options.height,
                0,
                0,
                this._inputVideoElement.width,
                this._inputVideoElement.height
            );
    
    
            this._outputCanvasCtx.globalCompositeOperation = "source-in";
            this._outputCanvasCtx.filter = "none";
    
            // Draw the foreground video.
            this._outputCanvasCtx.drawImage(this._inputVideoElement, 0, 0);
    
            // Draw the background.
            this._outputCanvasCtx.globalCompositeOperation = "destination-over";
    
            if (this._options.background.type == "vb") {
                let image = this._virtualImage;
                const imageRatio = image.width / image.height;
                const canvasRatio = this._inputVideoElement.width / this._inputVideoElement.height;
                let scaleFactor, newWidth, newHeight, xPosition, yPosition;

                if (imageRatio < canvasRatio) {
                    scaleFactor = this._inputVideoElement.width / image.width;
                    newWidth = this._inputVideoElement.width;
                    newHeight = image.height * scaleFactor;
                    xPosition = 0;
                    yPosition = (this._inputVideoElement.height - newHeight) / 2;
                } else {
                    scaleFactor = this._inputVideoElement.height / image.height;
                    newWidth = image.width * scaleFactor;
                    newHeight = this._inputVideoElement.height;
                    xPosition = (this._inputVideoElement.width - newWidth) / 2;
                    yPosition = 0;
                }
                // enxLog(`Image Height:: ${image.height} __ Image width:: ${image.width} __ Canvas width:: ${this._inputVideoElement.width} __ Canvas height:: ${this._inputVideoElement.height}`);
                this._outputCanvasCtx.drawImage(
                    this._virtualImage, xPosition, yPosition, newWidth, newHeight
                );
            } else if (this._options.background.type == "blur") {
                this._outputCanvasCtx.filter = `blur(8px)`;
                this._outputCanvasCtx.drawImage(this._inputVideoElement, 0, 0);
            } else {
                this._outputCanvasCtx.filter = "none";
                this.stopEffect();
                this.localStream.play(`#${this.previewPlayer.id}`, this._options.localOptions);
            }
        }
    }

    runInference() {
        this._model._runInference();
        const outputMemoryOffset = this._model._getOutputMemoryOffset() / 4;

        for (let i = 0; i < this._segmentationPixelCount; i++) {
            const background = this._model.HEAPF32[outputMemoryOffset + i * 2];
            const person = this._model.HEAPF32[outputMemoryOffset + i * 2 + 1];
            const shift = Math.max(background, person);
            const backgroundExp = Math.exp(background - shift);
            const personExp = Math.exp(person - shift);

            // Sets only the alpha component of each pixel.
            this._segmentationMask.data[(i * 4) + 3] =
                (255 * personExp) / (backgroundExp + personExp);
        }
        this._segmentationMaskCtx.putImageData(this._segmentationMask, 0, 0);

        // this._model._runInference();
        // const outputMemoryOffset = this._model._getOutputMemoryOffset() / 4;

        // for (let i = 0; i < this._segmentationPixelCount; i++) {
        //     const person = this._model.HEAPF32[outputMemoryOffset + i];

        //     // Sets only the alpha component of each pixel.
        //     this._segmentationMask.data[(i * 4) + 3] = 255 * person;

        // }
        // this._segmentationMaskCtx.putImageData(this._segmentationMask, 0, 0);
    }

    _renderMask() {
        if (this._options.background.type != 'none') {
            this.resizeSource();
            this.runInference();
            this.runPostProcessing();
            this._maskFrameTimerWorker.postMessage({
                id: SET_TIMEOUT,
                timeMs: 1000 / 30,
            });
        } else {
            this.stopEffect();
        }
    }

    resizeSource() {
        this._segmentationMaskCtx.drawImage(
            this._inputVideoElement,
            0,
            0,
            this._inputVideoElement.width,
            this._inputVideoElement.height,
            0,
            0,
            this._options.width,
            this._options.height
        );

        const imageData = this._segmentationMaskCtx.getImageData(
            0,
            0,
            this._options.width,
            this._options.height
        );
        const inputMemoryOffset = this._model._getInputMemoryOffset() / 4;

        for (let i = 0; i < this._segmentationPixelCount; i++) {
            this._model.HEAPF32[inputMemoryOffset + (i * 3)] = imageData.data[i * 4] / 255;
            this._model.HEAPF32[inputMemoryOffset + (i * 3) + 1] = imageData.data[(i * 4) + 1] / 255;
            this._model.HEAPF32[inputMemoryOffset + (i * 3) + 2] = imageData.data[(i * 4) + 2] / 255;
        }
    }

    estartEffect(stream, name = "preview") {
        if (!this._maskFrameTimerWorker) {
            let workerName = 'Virtual bgp effect worker';
            if (name == 'main') {
                workerName = 'Virtual bgm effect worker';
            }
            this._maskFrameTimerWorker = new Worker(timerWorkerScript, {
                name: workerName,
            });
            this._maskFrameTimerWorker.onmessage = this._onMaskFrameTimer;
        } else {
            console.log('terminating worker...');
            this.stopEffect();
        }

        const firstVideoTrack = this.localStream.stream.getVideoTracks()[0];
        if (firstVideoTrack) {
            let { height, frameRate, width } = firstVideoTrack.getSettings() ?? firstVideoTrack.getConstraints();
            console.log('height, frameRate, width: ', height, frameRate, width);
            if (height && width && frameRate) {

                this._segmentationMask = new ImageData(
                    this._options.width,
                    this._options.height
                );
        
                this._segmentationMaskCanvas = document.createElement("canvas");
                this._segmentationMaskCanvas.width = this._options.width;
                this._segmentationMaskCanvas.height = this._options.height;
                this._segmentationMaskCtx = this._segmentationMaskCanvas.getContext("2d", { willReadFrequently: true });
        
                let outputCanvasWidth = parseInt(width, 10);
                let outputCanvasHeight = parseInt(height, 10);
        
                this._outputCanvasElement.width = outputCanvasWidth;
                this._outputCanvasElement.height = outputCanvasHeight;
                this._outputCanvasElement.style.position = 'absolute';
                this._outputCanvasElement.style.top = '0';
                this._outputCanvasElement.style.right = '0';
                this._outputCanvasElement.style.zIndex = '9990';
                this._outputCanvasElement.style.display = 'none';
        
                this._outputCanvasCtx = this._outputCanvasElement.getContext("2d", { willReadFrequently: true });
                this._inputVideoElement.width = outputCanvasWidth;
                this._inputVideoElement.height = outputCanvasHeight;
        
        
                document.body.prepend(this._inputVideoElement);
                document.body.prepend(this._outputCanvasElement);
                this._inputVideoElement.autoplay = true;
                this._inputVideoElement.muted = true;
                this._inputVideoElement.srcObject = stream;
        
                this._inputVideoElement.onloadeddata = () => {
                    this._maskFrameTimerWorker.postMessage({
                        id: SET_TIMEOUT,
                        timeMs: 1000 / 30
                    });
                };
        
                return this._outputCanvasElement.captureStream(parseInt(frameRate, 10));
            }
        }
    }

    stopEffect() {
        this._maskFrameTimerWorker.postMessage({
            id: CLEAR_TIMEOUT
        });

        this._maskFrameTimerWorker.terminate();
    }
}
